import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
  ) {
    deleteOneFertilizer(
      where: {
        id: $id
      }
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Fertilizante eliminado`, mutationTypes.DELETE)
)

